import { useTranslation } from 'react-i18next';
import { HStack, View, Box, useTheme, Divider, IconButton, CloseIcon } from 'native-base';
import { PinIcon } from 'lucide-react';

import { Button, Text } from '@pimm/base';

type ConfirmPositionOverrideProps = {
  onClose: (_confirm?: boolean) => void;
};

export const ConfirmPositionOverride = (_props: ConfirmPositionOverrideProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <View p={1}>
      <HStack space={2} alignItems="center" mb={4}>
        <Box rounded="full" boxSize={9} alignItems="center" justifyContent="center" bg="primary.100">
          <PinIcon size={20} color={colors.primary[700]} />
        </Box>
        <Box flex={1}>
          <Text color="black" fontWeight={600} size="xl" lineHeight="sm">
            {t('positioning_plan:core_position_override_title')}
          </Text>
        </Box>

        <IconButton
          variant="unstyled"
          boxSize={7}
          p={0}
          _hover={{ bg: 'gray.50' }}
          icon={<CloseIcon size="16px" color="gray.500" />}
          onPress={() => _props.onClose(false)}
        />
      </HStack>

      <Box mb={3}>
        <Text color="gray.600" fontWeight={500} size="md" mb={3} lineHeight="md">
          {t('positioning_plan:core_position_override_message')}
        </Text>
      </Box>

      <Box rounded="lg" p={3} bg="primary.100">
        <Text color="gray.900" fontWeight={500} size="md" mb={3} lineHeight="md">
          {t('positioning_plan:core_position_override_note')}
        </Text>
      </Box>

      <Divider my={5} />

      <HStack space={2}>
        <Button flex={1} shadow={0} onPress={() => _props.onClose(false)}>
          {t('positioning_plan:cancel')}
        </Button>
        <Button variant="unstyled" shadow={0} flex={1} bg="white" onPress={() => _props.onClose(true)}>
          {t('positioning_plan:override_anyway')}
        </Button>
      </HStack>
    </View>
  );
};
